import {createSlice} from '@reduxjs/toolkit';

const accountSourcesSlice = createSlice({
    name: 'accountSources',
    initialState: [],
    reducers: {
        setAccountSources: (_, action) => action.payload,
        addAccountSource: (state, action) => [...state, action.payload],
        updateAccountSourceById: (state, action) =>
            state.map(s => s.id === action.payload.id ? action.payload : s),
        removeAccountSourceById: (state, action) =>
            state.filter(s => s.id !== action.payload),
    },
    selectors: {
        selectAccountSources: s => s,
    },
});

export const {
    setAccountSources,
    addAccountSource,
    updateAccountSourceById,
    removeAccountSourceById,
} = accountSourcesSlice.actions;
export const {selectAccountSources} = accountSourcesSlice.selectors;
export const {reducer} = accountSourcesSlice;
